import { trafficViewTabAtom } from "./atom"

export default trafficViewTabAtom
